export const TOGGLE_FOLLOW_TOPIC = 'toggleFollow/TOGGLE_FOLLOW_TOPIC';
export const TOGGLE_FOLLOW_TOPIC_FAIL = 'toggleFollow/TOGGLE_FOLLOW_TOPIC_FAIL';
export const TOGGLE_FOLLOW_TOPIC_SUCCESS = 'toggleFollow/TOGGLE_FOLLOW_TOPIC_SUCCESS';

export const FOLLOW_TOPIC_URL = topicId => `/advisor-service/topics/${topicId}/follow`;
